<!-- 1005：退款申请 -->
<template>
     
    <el-card class="newtable"  style="width:96%;margin-left:auto;margin-right:auto">
        
        <div slot="header" class="clearfix">
            <span> 退款申请 </span>
            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
            <el-button type='text' style="float: right; padding: 3px 0;color:black" >填表日期： {{form.createDate}}</el-button>
        </div>
    

        <el-form ref="form" :model="form" label-width="150px" class="formtable">
            <!-- <el-col :span="24"   >
                <div class="tag_item"  >客户信息 </div>
            </el-col> -->


            <el-col :span="24"   >
                <div class="tag_item"  >案件信息</div>
            </el-col>
 
            <el-form-item label="*退费金额">
                <el-col :span="20"  >
                    <el-input    v-model="form.amount"  type='number' ></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="*相关案件">
                <el-col :span="20"  >
                    <el-input :readonly="true"  v-model="form.caseinfo.case_name"  disabled></el-input>
                </el-col>


                <el-col :span="3" style="text-align:center" v-if="mode=='new' || mode=='edit' || mode=='rewrite' " >
                        
                    <el-button   icon="el-icon-search" circle  style="margin-left:30px "  @click="GetCaseList"></el-button>
                            
                </el-col>

                <el-col :span="3" style="text-align:center" v-else >  
                    <el-button type="primary" plain    icon="el-icon-d-arrow-right" circle  @click="CheckCaseDetail(form.caseinfo.sheet_id)"></el-button>   
                </el-col>


            </el-form-item>
       




            <div  v-for="(item,client_index) of form.clientinfo"  v-bind:key="client_index">
                <el-col :span="24"   >
                    <div class="tag_item"  >客户信息 {{form.clientinfo.length>1? client_index+1:'' }}</div>
                </el-col>


                <el-form-item label="*客户名称">
                    <el-col :span="18"   >
                        <el-input :readonly="isReadOnly"  v-model="form.clientinfo[client_index].client_name"></el-input>
                    </el-col>
                    <el-col :span="5" style="text-align:center"  >
                    <!-- <el-button v-if="(mode=='new' || mode=='edit' || mode=='rewrite')  && client_index==form.clientinfo.length-1" icon="el-icon-plus" circle   @click="PlusItem('client')"></el-button>

                    <el-button v-if=" (mode=='new' || mode=='edit' || mode=='rewrite')  &&client_index>0" icon="el-icon-minus" circle   style="margin-left:30px"  @click="DeleteItem('client',client_index)"></el-button> -->

                    <el-button v-if="mode=='new' || mode=='edit'" icon="el-icon-search" circle  style="margin-left:30px "  @click="GetClientList(client_index)"></el-button>
                    <el-button v-else type="primary" plain    icon="el-icon-d-arrow-right" circle  @click="CheckClientDetail(form.clientinfo[client_index].sheet_id)"></el-button>   
  
                    </el-col>

                </el-form-item>

                <el-form-item label="联系人">
                    <el-col :span="10"  >
                        <el-input :readonly="isReadOnly"  v-model="form.clientinfo[client_index].client_contact"  ></el-input>
                    </el-col>
                   
                    <el-col class="line" :span="3"  >  联系方式 </el-col>
                    <el-col :span="10"   >
                        <el-input :readonly="isReadOnly"  v-model="form.clientinfo[client_index].client_phone"  ></el-input>
                    
                    </el-col>
                
                </el-form-item>

                <el-form-item label="联系地址">
                    <el-col :span="23"  >
                        <el-input  :readonly="isReadOnly"  v-model="form.clientinfo[client_index].client_address"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="是否是自然人">
                    

                    <el-col :span="10">
                        <!-- :disabled="mode=='check' || mode=='examine'"  -->
                        <el-switch  disabled  v-model="form.clientinfo[client_index].client_isPerson"></el-switch>
                    </el-col>
                    
                    <el-col class="line" :span="3"  v-if="form.clientinfo[client_index].client_isPerson">  身份证 </el-col>
                    <el-col :span="10"  v-if="form.clientinfo[client_index].client_isPerson">
                        <!-- :readonly="isReadOnly" -->
                        <el-input  :readonly="true"    v-model="form.clientinfo[client_index].client_identity"  ></el-input>
                    
                    </el-col>



                </el-form-item>

            </div>

 

 


            <!-- <el-form-item label="关联附件">
                <el-col :span="10">
                    <el-radio v-model="form.seal_affix_radio" label="1">上传</el-radio>
                    <el-radio v-model="form.seal_affix_radio" label="2">从已上传文件中选取</el-radio>
                </el-col> 
            </el-form-item> -->

            <!-- v-if=" (mode=='new' || mode=='rewrite')&& form.seal_affix_radio=='1' " -->

            <el-form-item label="相关附件"  >

                <el-col :span="23"    v-if="mode=='new' || mode=='rewrite'  || mode=='edit' "  >
                    <el-upload
                        multiple
                       :action="this.$root.rootUrl+'oa_upload'"
                        list-type="picture-card"
                        with-credentials
                        :data="uploadData"
                        :on-success="handleUploadSuccess"
                        :before-upload="handleUploadbefore"
                        :file-list="mode=='check'||mode=='examine'? form.fileList: file_list"
                        :on-change="handleChange"
                        :disabled="mode!='new' && mode!='rewrite'" 
                        ref="upload"
                        >
                            <i  slot="default" class="el-icon-plus"></i>
                            <div slot="file" slot-scope="{file}" style="display:flex;flex-direction:column">
                                <!-- <img
                                    class="el-upload-list__item-thumbnail"
                                    :src="file.url" alt=""
                                > -->
                                <img v-if='file.name.indexOf(".pdf")!=-1' src="@/assets/images/PDF.png"  :alt="file.name"  class="el-upload-list__item-thumbnail"> 
                                <img v-else-if='file.name.indexOf(".doc")!=-1' src="@/assets/images/word.png" :alt="file.name" class="el-upload-list__item-thumbnail"> 
                                <img v-else-if='file.name.indexOf(".xlsx")!=-1 || file.name.indexOf(".csv")!=-1' src="@/assets/images/excel.png" :alt="file.name"   class="el-upload-list__item-thumbnail"> 
                                <img v-else-if='file.name.indexOf(".ppt")!=-1 || file.name.indexOf(".pptx")!=-1' src="@/assets/images/ppt.png" :alt="file.name" class="el-upload-list__item-thumbnail">  
                                <img v-else :src="file.url" :alt="file.name" @click="CheckFile(item)" class="el-upload-list__item-thumbnail">


                                <span class="el-upload-list__item-actions">
                                    <span
                                    class="el-upload-list__item-preview"
                                        @click="handlePictureCardPreview(file)"
                                    >
                                    <i class="el-icon-zoom-in"></i>
                                    </span>

                                    <span
                                    class="el-upload-list__item-delete"
                                    @click="handleDownload(file)"
                                    >
                                        <i class="el-icon-download"></i>
                                    </span>
                                    
                                    <span
                                    v-if="mode=='new' || mode=='rewrite'"
                                    class="el-upload-list__item-delete"
                                    @click="handleRemove(file)"
                                    >
                                        <i class="el-icon-delete"></i>
                                    </span>
                                </span>

                                <span style="position:absolute;bottom:2px;text-align:center;width:100%;line-height:14px ">
                                    <p>{{file.name}}</p>
                                </span>
                            </div>
                    </el-upload>



                        

                </el-col>

                <affix_box v-else :affixfileList="form.fileList"> </affix_box>

                <!-- <el-col :span="23" v-else class="affix_wrap"  >
                    <div class="affix_box"  v-for="(item) of form.fileList"   :key="item.id">
                        <div class="up">  
                             


                            <img v-if='item.fileName.indexOf(".pdf")!=-1' src="@/assets/images/PDF.png" alt="" @click="OpenFile(item.tempLink)"> 
                            <img v-else-if='item.fileName.indexOf(".doc")!=-1' src="@/assets/images/word.png" alt="" @click="OpenFile(item.tempLink)"> 
                            <img v-else-if='item.fileName.indexOf(".xlsx")!=-1 || item.fileName.indexOf(".csv")!=-1' src="@/assets/images/excel.png" alt="" @click="OpenFile(item.tempLink)"> 
                            <img v-else-if='item.fileName.indexOf(".ppt")!=-1 || item.fileName.indexOf(".pptx")!=-1' src="@/assets/images/ppt.png" alt="" @click="OpenFile(item.tempLink)">  

                            <img v-else :src="item.tempLink" :alt="item.fileName" @click="CheckFile(item)">


                        </div>
                        <div class="down">{{item.fileName}}  </div>

                         
                    </div>
                </el-col>

                <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt=""  >
                </el-dialog> -->
             
           </el-form-item>



     
            <!-- <el-divider content-position="center">开票信息</el-divider> -->

          

            <!-- <el-divider content-position="center">备注</el-divider> -->

            <!-- <el-col :span="24"   >
                <div class="tag_item"  >备注 </div>
            </el-col> -->

            <el-form-item label="*退款理由和说明">
                <!-- <el-input v-model="form.remarks"></el-input> -->
                <el-col :span="23" >
                <el-input
                    type="textarea"
                    :readonly="isReadOnly"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    placeholder="请输入内容"
                    v-model="form.remarks">
                </el-input>
                </el-col>
            </el-form-item>

            <el-form-item v-if="this.mode=='new' || this.mode=='edit' || this.mode=='rewrite' ">
                <el-col :span="11" >
                    <el-button type="primary" @click="NewFormSubmit" style="margin:auto;width:150px">提交</el-button>
                    <!-- <el-button style="margin:auto">取消</el-button> -->
                </el-col>

                <el-col :span="11" >
                    <!-- <el-button type="primary" @click="onSubmit" style="margin:auto">立即创建</el-button> -->
                    <el-button style="margin:auto;width:150px"  @click="CancelForm"  >取消</el-button>
                </el-col>


            </el-form-item>  

    



        
        </el-form>


    

    </el-card>

</template>

<script>
    function getNum() {
        var chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A',
            'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
            'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y',
            'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
            'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w',
            'x', 'y', 'z'];
        var nums = "";
        for (var i = 0; i < 8; i++) {
            var id = parseInt(Math.random() * 61);
            nums += chars[id];
        }
        return nums;
    }

  
    import affix_box from '@/components/oa/functions/affix_box.vue'


	export default {
        name: 'template_1005',
        props: {
            form:Object,
            mode:String,
        },
        components: { 
            affix_box
        },
        data() {
			return {
                isReadOnly:false,

                fileType:['法律服务合同','程序性文件','律师函','法律意见书','投标文件','其他'],
                sealType:['律所公章','合同文书章'],
                
                file_list:[],
                uploadData:{
                    'whattodo':"upLoadFiles"
                },
                dialogImageUrl:'',
                dialogVisible:false,
			}
        },
        mounted() {
         

            
            let t=setInterval(()=>{
                if(this.mode){
                    clearInterval(t)
                    if(this.mode!='new' && this.mode!='edit' && this.mode!='rewrite'){
                        this.isReadOnly=true
                    }


                    if(this.mode=='rewrite' && this.form.fileList && this.form.fileList.length>0){

                        this.file_list=this.form.fileList 
                        console.log('=======================this.file_list:',this.file_list)

                        
                    }

                }


            },500)



             


            // this.screenWidth = document.body.clientWidth;
            // this.screenHeight = document.body.clientHeight;
            // window.onresize = () => {
            //     return (() => {
            //         window.console.log('document.body.clientWidth:',document.body.clientWidth)
            //         window.console.log('document.body.clientHeight:',document.body.clientHeight)
                   
            //         this.screenWidth = document.body.clientWidth;
            //         this.screenHeight = document.body.clientHeight;
            //         if (document.body.clientWidth<=1100){
            //             this.rightOnShow=false
            //         }else{
            //              this.rightOnShow=true
            //         }

            //     })();
            // };
        },
        methods: {

            NewFormSubmit(){
                let obj={"template_id":"1005" , "sheet_name":"退款申请表" }
                console.log('1001 NewFormSubmit emit')
                this.$emit('SubmitNewForm',obj); 
            },

           CancelForm(){
                window.close();

            },

            handlePictureCardPreview(file) {
                console.log("handlePictureCardPreview file:",file)
                this.dialogImageUrl = file.url || file.fileLink ;
                this.dialogVisible = true;
            },



            handleUploadbefore(file){
             
                console.log("handleUploadbefore start file:",file)
                const fileType = file.type  ;
                const isLt50M = file.size < 50*1024*1024 ;
                if (!isLt50M){
                    this.$message.error('上传文件大小不能超过50MB!');
                }
                // if(!fileType){
                //   this.$message.error('不能上传目录!');
                // }


                window.console.log(isLt50M)
                if(isLt50M ){
                    // this.uploadData={
            //   'id':guid2(),
            //   'whattodo':"upLoadFiles",
            //   'articleId':this.article.docid
            // }
                this.uploadData.name=file.name
                this.uploadData.flow_id=this.form.flow_id
                 
                // window.console.log('this.uploadData:',this.uploadData)
                this.uploadData.whattodo="upLoadFiles"
                // this.uploadData.articleId=this.article.docid
                // this.uploadData.id=file.uid
                return isLt50M ;
                }else{
                return false
                }

            },



            handleUploadSuccess(res, file){
                // let a = URL.createObjectURL(file.raw);
                window.console.log('upload success res: ',res)

                
                // window.console.log('file_list:',this.file_list)
                window.console.log('upload success file: ',file)
                if (res.status=='ok'){
                    let obj={
                    "name":res.fileName,
                    'fileName':res.fileName,
                    'fileLink':res.fileLink,
                    'lastModified':file.raw.lastModified,
                    'id':res.id,
                    // "url":file.url
                    }
                    window.console.log('obj: ',obj)
                    // this.article.files.push(obj)
                    // this.Add2FileList(obj)
                    this.form.fileList.push(obj)

                    // this.file_list.push(obj)

                    console.log("file_list:",this.file_list)
                    console.log(" this.form.fileLis:", this.form.fileList)
                    // this.form.fileList=this.fileList



                }else if(res.status=='fail'){
                    if(res.errCode==4005){
                        this.$message({
                            type: 'info',
                            message: '不能上传超过5个文件噢'
                        }); 
                    }else if(res.errCode==4002){
                        this.$message({
                            type: 'info',
                            message: '文件大小合计不能超过5M'
                        }); 
                    }else if(res.errCode==4001){
                        this.$message({
                            type: 'info',
                            message: '文件为空'
                        }); 
                    }

                }
            


            },



        
            CheckFile(item){
               
                this.dialogImageUrl = item.tempLink ;
                this.dialogVisible = true;

                // window.open(item.tempLink)


            },


            GetClientList(index){
                
                this.$emit('GetClientList',index); 
            },


            GetCaseList(){
                this.$emit('GetCaseList'); 
            },




            handleDownload(file) {
                console.log(file);
            },
            

      
            handleRemove(file) {
                console.log('handleRemove ++++++++++',file);


                var that=this
                var datas= { 
                    fileLink:file.response.fileLink,
                    whattodo: "delete_file",
                    fileName:file.response.fileName,
                    // flow_id:this.form.flow_id
                }
                this.axios.post(this.$root.rootUrl+'oa',datas
                ).then(function (res) {
                    window.console.log(res)

                    if(res.status==200){
                        let result=res.data
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning'
                            });
                        }else if (result.status=='ok'){

                            that.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            that.DeleteFromFileList(file)
                            that.DeleteFromFileList2(file)
  

                            let id=file.response.id

                            // console.log('id:',id)
                            console.log('that.form.fileList:',that.form.fileList)

                            console.log("this.$refs.upload.fileList:",that.$refs.upload.fileList)

                            let fileList=that.$refs.upload.fileList
                            let ind1=fileList.findIndex((value)=>value.response.id==id);
                            console.log("++++++++++++ind1:",ind1)
                            if(ind1!=-1){
                                that.$refs.upload.fileList.splice(ind1,1)
                            }


             

 
                        } else if (result.status=='fail'){
                            that.$message('删除失败');
                            
                        }


                        
                    }

                    
                }).catch(function (error) {
                    window.console.log(error);
                    // that.saving_sig=0
                });




            },

            DeleteFromFileList(obj){
                this.$emit('DeleteFromFileList',obj); 
            },
            DeleteFromFileList2(file){
                let id=file.response.id
                console.log('this.form.fileList:',this.form.fileList)
            
                console.log('id:',id)
                var ind=this.form.fileList.findIndex((value)=>value.id==id);

                // var ind=this.form.fileList.find((value,index,arr)=>{
                //     if(value.id==id){
                //         return index
                //     }
                // });

                console.log('ind:',ind)
                if(ind!=-1){
                    this.form.fileList.splice(ind,1)
                }
            },

            handleChange(file, fileList) {
                console.log('handleChange   file:',file,"fileList:",fileList)
                this.file_list=fileList

                // console.log(t)
                console.log('this.$refs.upload',this.$refs.upload)

                // this.$refs.upload.fileList=fileList
            },

            OpenFile(tempLink){
                window.open(tempLink)

            },



            CheckCaseDetail(_id){
                let routeData = this.$router.resolve({name:"form", params: {mode:'check' ,template_id: '1002' ,  id: _id} });
                window.open(routeData.href, '_blank'); 

            },

            CheckClientDetail(_id){
                let routeData = this.$router.resolve({name:"form", params: {mode:'check' ,template_id: '1001' ,  id: _id} });
                window.open(routeData.href, '_blank'); 
            }
             

        }
	}
	
</script>

<style>
/* .el-menu{
    color:black;
} */

 
 

</style>
